<template>
  <!-- <div id="container"> -->
    <!-- key解决动态路由匹配传参，内容不改变的问题 -->
    <router-view :key="route.fullPath" />
  <!-- </div> -->
  <template v-if="isLoading">
    <Loading />
  </template>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import Loading from '@/components/PageLoading'

export default {
  components: {
    Loading
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const isLoading = computed(() => store.getters['viewLoad/isLoading'])
    return {
      route,
      isLoading
    }
  }
}
</script>


<style lang="stylus">
</style>
